import React from 'react';

const InputButton = props => {
    const onClick = (e) => {
        e.preventDefault()

        props.onClick && props.onClick()
    }

    return (
        <a className={`input-button ${props.type}`} onClick={onClick}>{props.children}</a>
    )
};

export default InputButton;